import axios from 'axios'

const headers = {
  'Content-Type': 'application/json',
  Authorization: axios.defaults.headers.common.Authorization,
}
export const actions = {
  async fetchCustomerLogo({ commit }) {
    return axios
      .get(`./jsonAPI/customerLogo.json`, headers)
      .then((response) => {
        return response
      })
      .catch((error) => {
        throw error
      })
  },
}
